import NanoModal from "./components/modal";
import initPdfGenerator from "./components/pdf-generator";
import tippy from "tippy.js";

function extraInfoTippy() {
  const tippyElements = document.querySelectorAll(
    "#tippyExtraInfo, .tippy-extra-info, [data-tippy-content]"
  );
  if (tippyElements.length === 0) {
    return;
  }

  tippyElements.forEach((tippyElement) => {
    const tippyContent = tippyElement.dataset.tippyContent;
    if (!tippyContent) {
      return;
    }

    tippy(tippyElement, {
      content: tippyContent,
      allowHTML: true,
      interactive: true,
      arrow: true,
      placement: "bottom-start",
      trigger: "click",
      theme: "light",
    });
  });
}

function openMenu() {
  function init() {
    const btn = document.querySelector(".mobile-menu-btn");
    const menu = document.querySelector(".mobile-menu-wrap");

    const menuItems = document.querySelectorAll(".mobile-menu-items a");

    btn.addEventListener("click", () => {
      btn.classList.toggle("active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });

    const innerCTA = document.querySelector(".mobile-menu-wrap .btn-filled");

    innerCTA.addEventListener("click", () => {
      btn.click();
    });

    menuItems.forEach((item) => {
      item.addEventListener("click", () => {
        btn.click();
      });
    });
  }

  const isPresent = document.getElementsByClassName("mobile-menu-btn");
  if (isPresent.length > 0) {
    init();
  }
}

function runOnLoadAndDocumentReady() {
  // Contact modal triggers
  const contactModalTriggers = document.querySelectorAll(".js-contact-modal");
  contactModalTriggers.forEach((trigger) => {
    const targetModalId = trigger.getAttribute("aria-controls");
    const targetModal = document.querySelector("#" + targetModalId);
    if (targetModal) {
      const modal = new NanoModal(targetModal, {
        onShow: () => {
          contactModalTriggers.forEach((trigger) => {
            trigger.setAttribute("aria-expanded", "true");
          });
        },
        onClose: () => {
          contactModalTriggers.forEach((trigger) => {
            trigger.setAttribute("aria-expanded", "false");
          });
        },
      });
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        modal.showModal();
      });
    }
  });

  extraInfoTippy();
  openMenu();
  initPdfGenerator();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runOnLoadAndDocumentReady);
} else {
  runOnLoadAndDocumentReady();
}
